<template>
  <v-card
    v-if="properties != null"
    class="small-centered-card white"
    flat
    height="100%"
  >
    <div class="card-content">
      <div>
        <v-row dense>
          <v-col cols="3" style="max-width:75px;">
            <CImage
              v-if="properties.image != null"
              :url="properties.image"
              :alt="properties.title"
              :contain="image_contained"
              width="50px"
              height="50px"
              size="50px"
            ></CImage>
          </v-col>
          <v-col style="display: flex;">
            <span
              v-if="properties.title != null"
              class="card-title small-compact-card-title dark_grey--text"
            >
              {{ properties.title }}
            </span>
          </v-col>
        </v-row>
      </div>
      <v-card-subtitle v-if="properties.subtitle != null" class="card-subtitle">
        {{ properties.subtitle }}
      </v-card-subtitle>
      <div v-if="properties.paragraphe != null">
        <template v-for="(txt, id) in properties.paragraphe">
          <CText class="mt-3" :text="txt" :key="id" text_type="paragraphe" />
        </template>
      </div>
      <div v-if="properties.text != null">
        <template v-for="(elem, id) in properties.text">
          <CText
            class="mt-3"
            :text="elem"
            :key="id"
            :text_type="text_type"
            :color_text="text_color"
          />
        </template>
      </div>
      <div v-if="properties.list != null">
        <CList
          :list="properties.list"
          :color="this.$vuetify.theme.themes.light.blue_6"
        />
      </div>
    </div>
  </v-card>
</template>

<style scoped>
.v-list-item {
  padding-left: 0px !important;
  padding-right: 0px !important;
}

.small-centered-card {
  background-color: #fafefe;
  padding: 25px;
  border-radius: 14px;
}

.small-compact-card-title {
  margin: auto auto auto 0;
}
</style>

<script>
import CImage from "../SubComponents/Image";
import CList from "../SubComponents/List";

export default {
  name: "SmallCenterCard",
  data: () => ({
    text_color: "medium_grey",
    text_type: "simple_text"
  }),
  components: {
    CImage,
    CList
  },
  props: {
    properties: {
      type: Object,
      default: null
    },
    image_contained: {
      type: Boolean,
      default: false
    },
    variant_color: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped>
.card-image {
  display: flex;
}
</style>
